import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { Redirect, useLocation } from 'react-router-dom';
import { defaultAuthorizedRoute } from '~/constants';
import { useStore } from '~/contexts';
import { useIntercomStarter } from '~/intercom/IntercomStarter';
import { useOptimizedMobileViewport } from '~/providers/MobileViewportWidthProvider';
import { selectors } from '~/store/state-selectors';
import { MobileDeviceEnhancer } from './MobileDeviceEnhancer/MobileDeviceEnhancer';
function useEnableIntercom(enableIntercom) {
    const { setEnableIntercom } = useIntercomStarter();
    useEffect(()=>{
        setEnableIntercom(enableIntercom);
    }, [
        enableIntercom,
        setEnableIntercom
    ]);
}
export function RouteWrapper(_0) {
    let { config } = _0, routeProps = _object_without_properties(_0, [
        "config"
    ]);
    const { component: Component, supportsMobileViewport = false, supportsMobileDevice = false, allowPartiallyOnboardedVendor = false, enableIntercom } = config;
    useOptimizedMobileViewport(supportsMobileViewport);
    useEnableIntercom(enableIntercom);
    const location = useLocation();
    const businessId = useStore(selectors.user.businessId);
    const userId = useStore(selectors.user.id);
    const isPartiallyOnboardedVendor = !!userId && !businessId;
    const shouldBlock = !allowPartiallyOnboardedVendor && isPartiallyOnboardedVendor;
    const defaultRouteForVendor = defaultAuthorizedRoute(true);
    if (shouldBlock) {
        return location.pathname === defaultRouteForVendor ? /*#__PURE__*/ _jsx("div", {
            "data-testid": "blocked-partially-onboarded-vendor"
        }) : /*#__PURE__*/ _jsx(Redirect, {
            to: {
                pathname: defaultRouteForVendor,
                search: location.search
            }
        });
    }
    const element = /*#__PURE__*/ _jsx(Component, _object_spread({}, routeProps));
    if (supportsMobileDevice) {
        return /*#__PURE__*/ _jsx(MobileDeviceEnhancer, {
            children: element
        });
    }
    return element;
}
